import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks'
import { Calendar } from '../../../../../ui/molecules/calendar'
import { InfoBox } from '../../../../../ui/molecules/infoBox'
import { ProtocolSearch } from '../../../../../ui/molecules/ProtocolSearch'
import { MadfarmStaticSelect } from '../../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../../ui/molecules/textArea'
import { formatterDate } from '../../../../../utils'
import { MeasureStatusOptions, RecourseResultOptions } from '../../../../../utils/measuresUtils'
import { MeasureVersionEnum } from '../../dataService/dto'
import { setNewMeasureExpirationMeasure, setNewMeasureUpdateActionPlaneProtocolId, setNewMeasureUpdateAppealReportDate, setNewMeasureUpdateAppealReportProtocolId, setNewMeasureUpdateClosingNote, setNewMeasureUpdateClosingProtocolId, setNewMeasureUpdateNextMeasureProtocolId, setNewMeasureUpdatePresentationDate, setNewMeasureUpdatePresentationProtocolId, setNewMeasureUpdateRacProtocolId, setNewMeasureUpdateReceiptProtocolId, setNewMeasureUpdateRecourseDate, setNewMeasureUpdateRecourseDetail, setNewMeasureUpdateRecourseNote, setNewMeasureUpdaterecourseResult, setNewMeasureUpdateResultProtocolId, setNewMeasureUpdateStatus, setNewMeasureUpdateStatusProtocolId } from '../../slice'

export function addDays(date?: Date, days?: number): Date | undefined {
    if (date === undefined) return undefined
    if (days === undefined) return date
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
}

export function AddNewCodexMeasureStep2Right() {
    const dispatch = useAppDispatch()
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const isOld = newMeasureState.getNewMeasureByIdResponse?.nonComplianceCodeVersion === MeasureVersionEnum.OLD
    const isNew = newMeasureState.getNewMeasureByIdResponse?.nonComplianceCodeVersion === MeasureVersionEnum.NEW

    return (
        <div className="p-6 flex flex-col gap-6">
            <div>
                <span className="text-brandPrimary-500 font-semibold text-lg">Provvedimenti </span>
                <span className="text-brandPrimary-300">/</span>
                <span className="text-brandPrimary-700 font-semibold"> Stato</span>
            </div>

            <div className="flex items-center gap-6 pb-4 border-b border-neutral-200">
                <span className="text-sm font-semibold text-neutral-700">Data Ricezione Provvedimento:</span>
                <span className="text-sm text-neutral-600">{formatterDate(newMeasureState.getNewMeasureByIdResponse?.activeFrom)}</span>
            </div>

            {isNew && (
                <InfoBox
                    color="green"
                    title="Termine delle Misure"
                    content={newMeasureState.getAllAppliedMeasureResponse?.data.map(am => ({ title: am.code, label: formatterDate(am.endingDate) }))}
                />
            )}

            {isOld && (
                <div className="flex flex-col gap-4">
                    <div className="grid grid-cols-2 gap-4">
                        <Calendar label="Attivo dal" disabled selected={newMeasureState.getNewMeasureByIdResponse?.activeFrom}
                            onChange={(date) => dispatch(setNewMeasureExpirationMeasure(addDays(date, newMeasureState.newMeasureUpdateRequest.terminationTreatment)))}
                        />
                        <Calendar label="Attivo al" disabled selected={newMeasureState.expirationMeasure} />
                    </div>
                    <ProtocolSearch label="Protocollo ricevuta" type="entry"
                        value={newMeasureState.newMeasureUpdateRequest.receiptProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateReceiptProtocolId(value))}
                    />
                </div>
            )}

            <MadfarmStaticSelect
                menuPortalTargetIsNotBody
                label="Stato del Provvedimento"
                placeholder="Seleziona stato..."
                options={MeasureStatusOptions}
                value={newMeasureState.newMeasureUpdateRequest.status}
                onChange={(value) => {
                    //@ts-ignore
                    dispatch(setNewMeasureUpdateStatus(value?.value))
                }}
                noOptionsMessage={""}
            />

            {isOld && (
                <div className="flex flex-col gap-4">
                    <ProtocolSearch label="Protocollo chiusura" type="entry"
                        value={newMeasureState.newMeasureUpdateRequest.closingProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateClosingProtocolId(value))}
                    />
                    <ProtocolSearch label="Rapporto Azione Correttiva (R.A.C.)" type="entry"
                        value={newMeasureState.newMeasureUpdateRequest.racProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateRacProtocolId(value))}
                    />
                </div>
            )}

            {isNew && (
                <div className="flex flex-col gap-4">
                    <ProtocolSearch label="Protocollo Stato" type="entry"
                        value={newMeasureState.newMeasureUpdateRequest.statusProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateStatusProtocolId(value))}
                    />
                    <ProtocolSearch label="Protocollo piano d'azione per la correzione della NC" type="entry"
                        value={newMeasureState.newMeasureUpdateRequest.actionPlaneProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateActionPlaneProtocolId(value))}
                    />
                </div>
            )}

            <TextArea label="Note Chiusura"
                value={newMeasureState.newMeasureUpdateRequest.closingNote}
                onChangeText={(text) => dispatch(setNewMeasureUpdateClosingNote(text))}
            />

            {isOld && (
                <ProtocolSearch label="Protocollo Provvedimento Successivo" type="departure"
                    value={newMeasureState.newMeasureUpdateRequest.nextMeasureProtocolId}
                    onSelect={(value) => dispatch(setNewMeasureUpdateNextMeasureProtocolId(value))}
                />
            )}

            {/* Gestione Ricorso */}
            <div className="border-t border-neutral-200 pt-4">
                <span className="text-brandPrimary-500 font-semibold text-lg">Provvedimenti </span>
                <span className="text-brandPrimary-300">/</span>
                <span className="text-brandPrimary-700 font-semibold"> Gestione Ricorso</span>
            </div>

            <div className="flex flex-col gap-4">
                <Calendar label="Data Presentazione"
                    selected={newMeasureState.newMeasureUpdateRequest.presentationDate}
                    onChange={(date) => dispatch(setNewMeasureUpdatePresentationDate(date))}
                />
                <ProtocolSearch label="Protocollo Presentazione" type="entry"
                    value={newMeasureState.newMeasureUpdateRequest.presentationProtocolId}
                    onSelect={(value) => dispatch(setNewMeasureUpdatePresentationProtocolId(value))}
                />
                <TextArea label="Dettaglio Ricorso"
                    value={newMeasureState.newMeasureUpdateRequest.recourseDetail}
                    onChangeText={(text) => dispatch(setNewMeasureUpdateRecourseDetail(text))}
                />
            </div>

            {isNew && (
                <div className="flex flex-col gap-4">
                    <Calendar label="Data Verbale Giunta d'Appello"
                        selected={newMeasureState.newMeasureUpdateRequest.appealReportDate}
                        onChange={(date) => dispatch(setNewMeasureUpdateAppealReportDate(date))}
                    />
                    <ProtocolSearch label="Protocollo Verbale Giunta d'Appello" type="departure"
                        value={newMeasureState.newMeasureUpdateRequest.appealReportProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateAppealReportProtocolId(value))}
                    />
                </div>
            )}

            <MadfarmStaticSelect
                menuPortalTargetIsNotBody
                label="Esito"
                placeholder="Seleziona risultato..."
                options={RecourseResultOptions}
                value={newMeasureState.newMeasureUpdateRequest.recourseResult}
                onChange={(value) => {
                    //@ts-ignore
                    dispatch(setNewMeasureUpdaterecourseResult(value?.value))
                }}
                noOptionsMessage={""}
            />

            {isOld && (
                <div className="flex flex-col gap-4">
                    <Calendar label="Data Esito"
                        selected={newMeasureState.newMeasureUpdateRequest.recourseDate}
                        onChange={(date) => dispatch(setNewMeasureUpdateRecourseDate(date))}
                    />
                    <ProtocolSearch label="Protocollo Esito" type="departure"
                        value={newMeasureState.newMeasureUpdateRequest.resultProtocolId}
                        onSelect={(value) => dispatch(setNewMeasureUpdateResultProtocolId(value))}
                    />
                </div>
            )}

            <TextArea label="Note"
                value={newMeasureState.newMeasureUpdateRequest.recourseNote}
                onChangeText={(text) => dispatch(setNewMeasureUpdateRecourseNote(text))}
            />
        </div>
    )
}